import { useCallback, useEffect, useRef, useState } from "react";

/** Load a job list; poll every 4 s while `isActive(row)` holds for any row. `onDone(row)` fires when a job finishes. */
export default function useJobsPoll(load, isActive, onDone) {
  const [rows, setRows] = useState(null);
  const prev = useRef({});
  const done = useRef(onDone);
  done.current = onDone;
  const refresh = useCallback(async () => {
    try {
      const next = await load();
      next.forEach((r) => { if (prev.current[r.id] && isActive({ status: prev.current[r.id] }) && r.status === "done") done.current?.(r); });
      prev.current = Object.fromEntries(next.map((r) => [r.id, r.status]));
      setRows(next);
    } catch { setRows((r) => r || []); }
  }, [load, isActive]);
  useEffect(() => { refresh(); }, [refresh]);
  const busy = Boolean(rows?.some(isActive));
  useEffect(() => {
    if (!busy) return undefined;
    const t = setInterval(refresh, 4000);
    return () => clearInterval(t);
  }, [busy, refresh]);
  return { rows, refresh };
}
